import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (_state: any, action: PayloadAction<any>) => ({ ...action.payload }),
    updateUserDetails: (state: any, action: PayloadAction<any>) => ({ ...state, ...action.payload }),
    resetUserDetails: () => initialState,
  },
});

export const { setUserDetails, updateUserDetails, resetUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
